/**
 * AttachmentPreviewModal.jsx
 * Path: frontend/src/components/AttachmentPreviewModal.jsx
 * Description: Lightbox do podglądu zdjęć i filmów ze zlecenia.
 * Related: components/AttachmentList.jsx, components/JobChat.jsx
 */

import { X } from "lucide-react";
import { isImageAttachment, isVideoAttachment } from "../utils/attachments";

export default function AttachmentPreviewModal({ item, onClose }) {
  if (!item?.attachment) {
    return null;
  }

  const { attachment, previewUrl } = item;
  const isImage = isImageAttachment(attachment);
  const isVideo = isVideoAttachment(attachment);

  return (
    <div className="modal-backdrop media-lightbox" role="presentation" onClick={onClose}>
      <div className="media-lightbox-card" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="ghost-button media-lightbox-close" onClick={onClose} aria-label="Zamknij podgląd">
          <X size={18} />
        </button>
        <div className="media-lightbox-header">
          <strong>{attachment.originalName}</strong>
          <span>{attachment.mimeType || "plik"}</span>
        </div>
        <div className="media-lightbox-body">
          {isImage && previewUrl ? <img src={previewUrl} alt={attachment.originalName} className="media-lightbox-image" /> : null}
          {isVideo && previewUrl ? (
            <video src={previewUrl} className="media-lightbox-video" controls playsInline preload="metadata" />
          ) : null}
          {((isImage || isVideo) && !previewUrl) || (!isImage && !isVideo) ? (
            <div className="media-lightbox-fallback">
              {isImage || isVideo
                ? "Podgląd tego pliku nie jest jeszcze gotowy. Spróbuj ponownie."
                : "Podgląd tego typu pliku nie jest dostępny. Użyj przycisku pobierania."}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
